export function formatDateToYMD(date) {
    if (!(date instanceof Date)) date = new Date(date);
    if (isNaN(date.getTime())) return '';
    return date.toISOString().slice(0, 10);
}